import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import Loader from 'react-loader-spinner';

import NoData from '../../no-data/no-data.component';
import { CREATE_MESSAGE } from './apis';
//styles
import { Row, Col, ListGroup, Tabs, Tab, Nav, Modal, Dropdown } from 'react-bootstrap';
import { Button, Fab, Chip, ClickAwayListener, TextField, InputLabel } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { Breadcrumbs, Typography } from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import img from '../../../images/person-placeholder.jpg';
import more from '../../../images/more.png';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import DoneIcon from '@material-ui/icons/Done';


function JobDetailCard(props) {
    const job = props.data;
    const notAnswered = props.notAnswered && props.notAnswered.ApplicationsGet.data;
    const shortlisted = props.shortlisted && props.shortlisted.ApplicationsGet.data;
    const rejected = props.rejected && props.rejected.ApplicationsGet.data;

    const [show, setShow] = useState(false);
    const [showReject, setShowReject] = useState(false);
    const [showSendMessage, setShowSendMessage] = useState(false);

    const [selectedApp, setSelectedApp] = useState();
    const [open, setOpen] = React.useState(false);
    let comment = "", commentError = "";

    const [sendMessage, { loading  , data }] = useMutation(CREATE_MESSAGE);

    const handleClick = () => {
        setOpen((prev) => !prev);
    };
    const checkComment = (e) => {
        if (e.target.value.length <= 5000)
            comment = e.target.value;
        else
            commentError = "this field length must be max 5000 long.";
    }
    const handleClickAway = () => {
        setOpen(false);
    };

    const handleShowApplication = (application) => {
        setShow(true);
        setSelectedApp(application)
    }
    const handleShowReject = (application) => {
        handleClickAway();
        setShowReject(true);
        setSelectedApp(application);
    }
    const handleShowSendMessage = (application) => {
        handleCloseApplication()
        handleClickAway();
        setShowSendMessage(true);
        setSelectedApp(application);
    }
    const handleCloseApplication = () => setShow(false);
    const handleCloseReject = () => setShowReject(false);
    const handleCloseSendMessage = () => setShowSendMessage(false);
    const handleApplicationAnswer = (id, is_accepted, comment) => {
        props.callBackFun(id, is_accepted, comment);
        handleClickAway();
        handleCloseApplication();
    }

    const LeftPart = () => (
        <div>
            <div className="shadow rounded p-3 mb-3">
                <h5 className="captialize">{job.title}</h5>
                <p className="text-orange mb-0">{job.company.name}<span className="text-grey pl-3">{job.created_at.substring(0, 10)}</span></p>
            </div>
            <div className="shadow rounded p-3 mb-3">
                <div>
                    <h6 className="bold">Job Description</h6>
                    <p className="text-orange  text-capitalize">{job.job_type && job.job_type.name} <span className="text-grey pl-3 text-capitalize">{job.job_level_of_experience_type && job.job_level_of_experience_type.name}</span></p>
                    <p>{job.brif}</p>
                </div>
                <Row className="m-0 mt-3">
                    <Col xs={4} className="text-left mb-1 text-center-sm p-0">
                        <FontAwesomeIcon icon={faUserFriends} size="lg" className="text-dark" />
                        <span className="pl-1">{job.ApplicationsGet.data && job.ApplicationsGet.data.length + ' Applicant'}</span>
                    </Col>
                    <Col xs={4} className="text-left mb-1 text-center-sm p-0">
                        <FontAwesomeIcon icon={faBoxOpen} size="lg" className="text-dark" />
                        <span className="pl-1">{job.questions && job.questions.length + ' Question'}</span>
                    </Col>
                </Row>
                <div className="text-left mb-1 mt-3">
                    <h6 className="p-0 mb-2 bold">Job Tags</h6>
                    {job.tags?.map(tag =>
                        <Chip className="mr-1" key={tag.name} label={tag.name} />
                    )}
                </div>
            </div>
            {job.questions.length > 0 &&
                <div className="shadow rounded p-3">
                    <div xs={12} className="text-left">
                        <h6 className="p-0 mb-2 bold">Questions</h6>
                        <ListGroup>
                            {job.questions?.map((question, index) =>
                                <ListGroup.Item style={{ width: 'fit-content' }} key={question.title} className="mb-2 border p-1 bg-lightgrey">{index + 1 + '- ' + question.title}</ListGroup.Item>
                            )}
                        </ListGroup>
                    </div>
                </div>}
        </div>
    )
    const RightPart = () => (
        <div>
            <div className="shadow rounded mb-3">
                <header className="bg-light p-3 border-bottom">
                    <h5 className="mb-0">Application <span className="bg-grey p-1 text-dark small">{notAnswered?.length}</span></h5>
                </header>
                <main>
                    {ListApplication(notAnswered)}
                </main>
            </div>
            <div className="shadow rounded mb-3">
                <Tab.Container id="left-tabs-example" className="p-1" defaultActiveKey="first">
                    <header className="row m-0 border-bottom p-3  bg-light">
                        <Nav variant="pills" >
                            <Nav.Item>
                                <Nav.Link eventKey="first" className="mr-3 bg-transparent text-center p-0" style={{ outline: 'none' }}>
                                    <h5 className="mb-0">Shortlist
                                    <span className="bg-grey ml-1 p-1 text-dark small">{shortlisted?.length}</span></h5>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="second" className="mr-3 bg-transparent text-center p-0" style={{ outline: 'none' }}>
                                    <h5 className="mb-0">Reject<span className="bg-grey p-1 ml-1 text-dark small">{rejected?.length}</span></h5>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </header>
                    <main>
                        <Tab.Content>
                            <Tab.Pane eventKey="first" className="p-1">
                                {ListApplication(shortlisted)}
                            </Tab.Pane>
                            <Tab.Pane eventKey="second" className="p-1">
                                {ListApplication(rejected)}
                            </Tab.Pane>
                        </Tab.Content>
                    </main>

                </Tab.Container>
            </div>
        </div>
    )
    const ListApplication = (application) =>
        application && application.length > 0 ? application.map(application =>
            <Row key={application.id} data-id={application.id} className="m-0 pt-3 pb-3 justify-content-center align-items-center">
                <Col lg={4} xs={8}>
                    <img style={{ cursor: 'pointer' , height : '95px' , width : '95px'}}
                        onClick={e => handleShowApplication(application)}
                        className="img-fluid rounded mb-1" 
                        src={application.user.profile_image? application.user.profile_image.url : img}
                         alt='list item img' />
                </Col>
                <Col
                    style={{ cursor: 'pointer' }}
                    onClick={e => handleShowApplication(application)}
                    className="text-left"
                    lg={6}
                    xs={10}>
                    <h6 className="mb-0">{application.user.name}</h6>
                    <p className="text-grey mb-0">{application.bio.speciality?.name}</p>
                    <p className="text-grey mb-0">
                        <DateRangeIcon className="mr-2" style={{ fontSize: '1rem' }} />
                        {application.bio.created_at.substring(0, 10)}
                    </p>
                </Col>
                <Col xs={1} className="text-right" >
                    <div>
                        <Dropdown className="d-inline-block ">
                            <Dropdown.Toggle
                                style={{ borderColor: '#E2E2E2' }}
                                className="btn-white border-0 dropdown-basic"
                                size="sm" variant="outlined" >
                                <img src={more} alt="dots" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu data-id={application.id} style={{ left: '-127px' }} className="pt-0 pb-0 shadow custom-list-jobs text-center" >
                                <Dropdown.Item
                                    onClick={e => {
                                        handleApplicationAnswer(application.id, true, '')
                                    }}
                                >Shortlist
                                </Dropdown.Item>
                                <Dropdown.Item onClick={e => handleShowReject(application)}>Reject</Dropdown.Item>
                                <Dropdown.Item onClick={e => handleShowSendMessage(application)}>Send message</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </Col>
            </Row>
        ) : <NoData />

    const ApplicationModel = () => (
        <Modal
            size="lg"
            className="row m-0  pr-0"
            show={show} onHide={handleCloseApplication}>
            <Col xs={12} className="p-0">
                <Modal.Header closeButton className="p-2 border-bottom bg-lightgrey row m-0">
                    <Modal.Title className="h5 p-2 pr-3 pl-3 captialize" >{selectedApp?.user.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {selectedApp &&
                        <div key={selectedApp.id}>
                            <Row key={selectedApp.id} data-id={selectedApp.id} className="m-0 mt-2 justify-content-center align-items-center">
                                <Col className="text-left" md={2} xs={4}>
                                    <img className="img-fluid rounded" src={selectedApp.user.profile_image? selectedApp.user.profile_image.url : img} width="100%" alt='list item img' />
                                </Col>
                                <Col className="p-0 text-left" md={4} xs={8}>
                                    <h6 className="mb-0">{selectedApp.user.name}</h6>
                                    <p className="text-grey mb-0">{selectedApp.bio.speciality?.name}</p>
                                    <p className="text-grey mb-0"><DateRangeIcon className="mr-2" style={{ fontSize: '1rem' }} />{selectedApp.bio.created_at.substring(0, 10)}</p>
                                </Col>
                                <Col className="text-right" md={6} xs={12}>
                                    <Button style={{ borderColor: '#E2E2E2', fontWeight: 'normal', fontSize: '16px', borderRadius: '12px' }}
                                        size="small"
                                        variant="outlined"
                                        className="btn-white mr-2"
                                        onClick={e => {
                                            handleCloseApplication();
                                            handleShowReject(selectedApp);
                                        }}>Reject</Button>
                                    <Button
                                        style={{ fontWeight: 'normal', fontSize: '16px', borderRadius: '12px' }}
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        className="btn-orange-gradiant mr-2 "
                                        onClick={e => handleApplicationAnswer(selectedApp.id, true, '')}>
                                        <DoneIcon style={{ fontWeight: 'normal', fontSize: '18px' }} className="mr-1" /> Shortlist
                                    </Button>
                                    <Dropdown className="d-inline-block">
                                        <Dropdown.Toggle
                                            style={{ borderColor: '#E2E2E2', borderRadius: '12px' }}
                                            className="btn-white dropdown-basic"
                                            size="sm"
                                            variant="outlined">
                                            <MoreHorizIcon style={{ fontWeight: 'normal', fontSize: '20px' }} />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="custom-list-jobs shadow p-0">
                                            <Dropdown.Item
                                                onClick={e => {
                                                    let id = selectedApp.id
                                                    props.history.push({
                                                        pathname: `/applicantprofile/${id}`
                                                    })
                                                }}
                                            >View Profile
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={e => handleShowSendMessage(selectedApp)}>Send message</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                            </Row>
                            <Row className="m-0">
                                <div className="col-12 pb-2 pt-2">
                                    <video controls width="100%" src={selectedApp.bio.video?.url} />
                                </div>
                            </Row>
                        </div>
                    }
                </Modal.Body>
            </Col>
        </Modal>
    )
    const SendMessage = (props) =>
    (
        <Modal
            size="md"
            className="row m-0  pr-0"
            show={props.show}
            onHide={props.hide}>
            <Col xs={12} className="p-0">
                <Modal.Header closeButton className="p-2 border-bottom bg-lightgrey row m-0">
                    <Modal.Title className="h5 col-8 p-2 pr-3 pl-3 captialize" >{props.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {selectedApp &&
                        <div key={selectedApp.id}>
                            <Row key={selectedApp.id} data-id={selectedApp.id} className="m-0 mt-2">
                                <Col className="text-left" xs={2}><img className="img-fluid rounded" src={selectedApp.user.profile_image? selectedApp.user.profile_image.url : img} width="100%" alt='list item img' /></Col>
                                <Col className="p-0 text-left" xs={6}>
                                    <h6 className="mb-0">{selectedApp.user.name}</h6>
                                    <p className="text-grey mb-0">{selectedApp.bio.speciality?.name}</p>
                                </Col>
                            </Row>
                            <Row className="m-0 mt-2">
                                <Col xs={12}>
                                    <InputLabel htmlFor="comment">
                                        {props.messageTitle}
                                    </InputLabel>
                                    <TextField
                                        required
                                        name="comment"
                                        id="comment"
                                        className="pt-1"
                                        onChange={checkComment}
                                        multiline
                                        rows="7"
                                        fullWidth
                                        variant="outlined"
                                        placeholder=""
                                        helperText="0 / 5000 Characters"
                                    />
                                </Col>
                                <Col xs={12} className="p-0">
                                    <Typography variant="subtitle1" className="text-danger">{commentError}</Typography>
                                </Col>
                            </Row>
                            <Row className="m-0 mt-2 mb-2">
                                <Col className="text-left" md={6}>
                                    <Button
                                        size="large"
                                        onClick={e => {
                                            if (props.type === 'reject') {
                                                handleCloseReject()
                                            } else {
                                                handleCloseSendMessage()
                                            }
                                        }}
                                        style={{ fontWeight: 'normal' }}
                                        className=" pr-4 pl-4 pt-1 pb-1 btn-white-outline"
                                    >Cancel</Button>
                                </Col>
                                <Col className="text-right" md={6}>
                                    <Button
                                        size="large"
                                        style={{ fontWeight: 'normal' }}
                                        onClick={e => {
                                            if (props.type === 'reject') {
                                                handleApplicationAnswer(selectedApp.id, false, comment);
                                                handleCloseReject();
                                            }
                                            else {
                                                sendMessage({ variables: { user_id: selectedApp.user.id , text: comment } });
                                                if(!loading){
                                                    handleCloseSendMessage();
                                                }
                                            }

                                        }}
                                        className=" pr-4 pl-4 pt-1 pb-1 btn-orange-gradiant"
                                    >Submit</Button>
                                </Col>
                            </Row>
                        </div>
                    }
                </Modal.Body>
            </Col>
        </Modal>
    )
    const BreadCrumb = () => (
        <div className=" rounded text-light pt-1 pb-3 mb-1">
            <Breadcrumbs aria-label="breadcrumb">
                <Link to="/jobs">
                    Jobs
                </Link>
                <Link aria-disabled="true">
                    Job Details
                </Link>
            </Breadcrumbs>
        </div>
    )
    return (
        <React.Fragment key={job.id}>
            {loading &&
                <div className="loading">
                    {/* <p className="text-white">saving your awesome video addons</p> */}
                    <Loader
                        type="TailSpin"
                        color="white"
                        height={50}
                        width={50}
                    />
                </div>
            }
            <main className="container  mt-5 mb-5">
                <BreadCrumb />
                <div className="row">
                    <section className="col-md-8">
                        <LeftPart />
                    </section>
                    <section className="col-md-4">
                        <RightPart />
                    </section>
                </div>
                <ApplicationModel />
                <SendMessage
                    show={showReject}
                    hide={handleCloseReject}
                    type="reject"
                    header="Send Feedback"
                    messageTitle="Write why you reject this candidate"
                />
                <SendMessage
                    show={showSendMessage}
                    hide={handleCloseSendMessage}
                    type="message"
                    header="Send Message"
                    messageTitle="Write your message here"
                />
            </main>
        </React.Fragment>
    )

}
export default withRouter(JobDetailCard)